import env from 'util/env';
import { gtag } from './gtag';

export function initGA() {
  if (!env.GOOGLEANALYTICS_ENABLED) {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  gtag('js', new Date());
  gtag('config', env.GOOGLEANALYTICS_TAGID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${env.GOOGLEANALYTICS_TAGID}`;
  document.head.appendChild(script);
}
